export function LinkDelIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M6.343 13.414a3 3 0 004.243 4.243l.419-.419a5.984 5.984 0 011.752-4.48 5.984 5.984 0 014.48-1.753l.42-.42a3 3 0 10-4.243-4.242l-2.121 2.121A1 1 0 019.879 7.05l2.12-2.121a5 5 0 017.483 6.607 6 6 0 11-7.946 7.946A5.001 5.001 0 014.929 12L7.05 9.879a1 1 0 011.414 1.414l-2.121 2.121zm7.668 4.583h5.984a1 1 0 100-2h-5.984a1 1 0 00-.675 1.738m.675.262c-.26 0-.497-.1-.675-.262l.675.262z"
      ></path>
      <path
        fill="currentColor"
        d="M9.171 14.828a1 1 0 010-1.414l4.243-4.242a1 1 0 111.414 1.414l-4.242 4.242a1 1 0 01-1.415 0z"
      ></path>
    </svg>
  );
}
